import React from 'react';
import { LozengeIcon, LozengeStyled, LozengeText } from './Lozenge.styles';
const Lozenge = ({ label, variant, color, icon, onClick, ...props }) => (React.createElement(LozengeStyled, { color: color, variant: variant, onClick: onClick, ...props },
    React.createElement(LozengeText, null, label),
    icon && React.createElement(LozengeIcon, { name: icon, size: 's' })));
export default Lozenge;
//# sourceMappingURL=Lozenge.js.map